import { getField, updateField } from "vuex-map-fields";
const timerSeconds = 300;
let tid = new Object();

const getDefaultState = () => {
  return {
    successFncForBiz: "",
    components: {
      isSelfCertnComm: true, // 인증 공통처리
      isSmsFrstCertn: false, // sms 최초인증  
      isSmsEmailCertn: false,  // sms/email 인증
    },
    Toast: {
      // toast
      isOpen: false,
      contents: "",
    },
    smsFrstCertn: {
      ogvtn: {
        certnNatnlCdArr: [
          { value: "84", text: "VND(+84)", selectText: "베트남: VND(+84)" },
          { value: "82", text: "KOR(+82)", selectText: "한국: KOR(+82)" }
        ],
      },
      ogcbd: {
        certnNatnlCdArr: [
          { value: "855", text: "KHM(+855)", selectText: "캄보디아: KHM(+855)" },
          { value: "82", text: "KOR(+82)", selectText: "한국: KOR(+82)" },
        ],
      },
    },
    /**
     * 예금계좌상세조회
     */
    RBF0404B40: {
      acnoSelect: {
        acno: "",
        acnoDetail: {
          acnKnd: "",
          bal: 0,
          cnpr: 0,
          ctrcTrmCnt: 0,
          expirYmd: "",
          lnBal: 0,
          newYmd: "",
          ovsesCustOcntryName: "",
          totalExtenCnt: 0,
          wwwBnkgJoinAbilYn: "",
        },
      },
      in: {
        acno: "", // 계좌번호
        brncoEcrypPwd: "", // 계좌비밀번호
        acnDsticCd: "", // 계좌구분코드 1:예금, 2:대출
        bizDscd: "", // 업무구분
        _nprotected: "", // 보안키패드
      },
      out: {
        success: {},
        fail: {},
      },
    },
    /**
     * 고객정보조회
     */
    RBF0409E40: {
      in: {},
      out: {
        success: {
          cphnNo: "", // 휴대폰 번호
          emad1: "", // 이메일 주소
          celNomalSendzYn: "0", // 휴대전화정상송신여부(0/1) 휴대전화번호를 고객이 검증했는지 여부
          celRecvCnsntYn: "0", // 휴대전화수신동의여부(0/1) 휴대전화 문자수신 동의 여부
          emailNomalSendzYn: "0", // 이메일정상송신여부(0/1) 이메일주소를 고객이 검증했는지 여부
          emailRecvCnsntYn: "0", // 이메일수신동의여부(0/1) 이메일 문자수신 동의 여부
          certnNatnlCd: "", // 인증국가코드
          certnCphnNo: "", // 인증휴대폰번호
          smsUseYn: "", //SMS사용여부
          smsCnptList: [], //SMS연락처리스트
          otpUniqIdnfiNo: "", // 보안장치고유식별번호
          scurtyDeviVndrDstcd: "", // 보안장치벤더구분코드
        },
        fail: {},
      },
    },

    /**
     * SMS연락처리스트 for select box
     */
    smsCnptList: [],

    /**
     * 인증코드 입력 남은 시간
     */
    sendTime: 0,
    /**
     * 인증코드(sms/email) 요청
     */
    sendCetrNo: {
      messageForTimeOut: false,
      in: {
        msgSendPtrnCd: "", // 1:SMS, 2:EMAIL
        ovsesSMSBzwkDstcd: "", // 해외SMS업무구분코드
        cphnNo: "", // 휴대폰번호
        cntpSerno: "", // 연락처일련번호
        emailAddr: "", // email주소
        certnNatnlCd: "", // 인증국가코드
        certnCphnNo: "", // 인증휴대폰번호
        recvCnsntYn: "", // 수신동의여부
        certnCnsntYn: "", // 인증문자수신여부
        certnNatnlCd_text: "", // 인증국가코드_text
      },
      out: {
        success: { certnNoSerno: "", certnNo: "" },
        fail: {},
      },
    },
    /**
     * 인증코드(sms/email) 확인
     */
    sendCetrNoConfirm: {
      in: {
        certnNoSerno: "", // 인증번호일련번호
        certnNo: "", // 인증번호
        bizDscd: "", // 업무구분코드
      },
      out: {
        success: { certnNoCnfrmRsultDstcd: "" },
        fail: {},
      },
    },
    /**
     * 고객연락처상세정보변경
     */
    RBF0509E51: {
      in: {
        custIdnfr: "", // 고객식별자
        brncoCntpDstcd: "", // 연락처구분코드(전화번호 : "03", "Email" : "04")
        ovsesSMSBzwkDstcd: "", //해외SMS업무구분코드
        cntpSerno: "", // 연락처일련번호
        natnlCd: "", // 국가코드
        cntpCtnt: "", // 연락처내용
        recvCnsntYn: "1", // 수신동의여부(0/1)
      },
      out: {
        success: {},
        fail: {},
      },
    },
    /**
     * OTP 인증
     */
    checkOtp: {
      in: {
        otpUniqIdnfiNo: "",
        otp: "",
        bizDscd: "", // 업무구분코드,
        _nprotected: "",
      },
      out: {
        success: {
          otpResult: "",
        },
        fail: {},
      },
    },
    /**
     * 이체한도조회
     */
    RBF0402N41: {
      in: {},
      out: {
        success: {
          ppsnCoprDstcd: "", //개인법인구분코드
          cncycd: "", //통화코드
          dailyTrsaccClam: "", //일일이체한도금액
          casPerTrsaccClam: "", //건별이체한도금액
        },
        fail: {},
      },
    },
  };
};

const commMotpCertn = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getComponents: state => {
      return state.components;
    },
    getSmsFrstCertn: state => {
      return state.smsFrstCertn;
    },
    getRBF0409E40: state => {
      return state.RBF0409E40;
    },
    getSMSCnptList: state => {
      return state.smsCnptList;
    },
    getSendCetrNo: state => {
      return state.sendCetrNo;
    },
    getSendCetrNoConfirm: state => {
      return state.sendCetrNoConfirm;
    },
    getToast: state => {
      return state.Toast;
    },
    getRBF0404B40: state => {
      return state.RBF0404B40;
    },
    getRBF0509E51: state => {
      return state.RBF0509E51;
    },
    getCheckOtp: state => {
      return state.checkOtp;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    /**
     * 인증코드 확인 데이터를 업데이트 함.
     * @param {*} state
     * @param {*} payload
     */
    mut001_commMotpCertn: function (state, payload) {
      const org = state.sendCetrNoConfirm.in[payload.key];
      this._vm.$set(state.sendCetrNoConfirm.in, payload.key, " ");
      if (payload.key === "certnNo" && payload.value.length > 6) {
        payload.value = org;
      }
      if (isNaN(payload.value)) {
        payload.value = org;
      }
      this._vm.$set(state.sendCetrNoConfirm.in, payload.key, payload.value);
    },
    /**
     * 인증코드 발송 데이터를 업데이트 함.
     * @param {*} state
     * @param {*} payload
     */
    mut002_commMotpCertn: function (state, payload) {
      const org = state.sendCetrNo.in[payload.key];
      this._vm.$set(state.sendCetrNo.in, payload.key, " ");
      if (payload.key === "certnCphnNo" && payload.value.length > 16) {
        payload.value = org;
      }
      this._vm.$set(state.sendCetrNo.in, payload.key, payload.value);
    },
    /**
     * 예금계좌 상세 조회 데이터를 업데이트 함.
     */
    mut003_commMotpCertn: function (state, payload) {
      this._vm.$set(state.RBF0404B40.in, payload.key, payload.value);
    },
    /**
     * 고객연락처상세정보변경 데이터를 업데이트 함.
     */
    mut004_commMotpCertn: function (state, payload) {
      this._vm.$set(state.RBF0509E51.in, payload.key, payload.value);
    },
    /**
     * OTP 인증 데이터를 업데이트 함.
     */
    mut005_commMotpCertn: function (state, payload) {
      const org = state.checkOtp.in[payload.key];
      this._vm.$set(state.checkOtp.in, payload.key, " ");

      if (payload.key === "otp") {
        if (payload.value.length > 6) {
          payload.value = org;
        }

        if (isNaN(payload.value)) {
          payload.value = org;
        }
      }
      this._vm.$set(state.checkOtp.in, payload.key, payload.value);
    },

  },
  actions: {
    /**
     * 고객정보조회
     * @param {*} context
     */
    act001_commMotpCertn: function (context) {

      return new Promise(resolve => {
        Object.assign(context.state, getDefaultState()); // 인증초기화..?
        this._vm.$post(
          "/auth/motp/issunc/RBF0409E40",
          context.state.RBF0409E40.in,
          response => {
            this._vm.$set(context.state.RBF0409E40.out, "success", response);
            context.state.smsCnptList = getDefaultState().smsCnptList;

            //SMS연락처
            for (let i = 0; i < context.state.RBF0409E40.out.success.smsCnptList.length; i++) {
              let temp = { text: "", value: "", data: {} };
              let ovsesSMSBzwkDstcd = context.state.RBF0409E40.out.success.smsCnptList[i].ovsesSMSBzwkDstcd;
              let cntpSerno = context.state.RBF0409E40.out.success.smsCnptList[i].cntpSerno;
              let brncoIntnTelDstcd = context.state.RBF0409E40.out.success.smsCnptList[i].brncoIntnTelDstcd;
              let cntpCtnt = context.state.RBF0409E40.out.success.smsCnptList[i].cntpCtnt;
              let recvCnsntYn = context.state.RBF0409E40.out.success.smsCnptList[i].recvCnsntYn;

              if (_.isNil(brncoIntnTelDstcd) || _.isEmpty(brncoIntnTelDstcd) || recvCnsntYn != "1") {
                temp.text = "+() " + cntpCtnt.slice(cntpCtnt.length * -1, cntpCtnt.length - 8) + "**"
                  + cntpCtnt.slice(-6, cntpCtnt.length - 4) + "**"
                  + cntpCtnt.slice(-2, cntpCtnt.length);
              } else {
                temp.text = "+(" + brncoIntnTelDstcd + ") " + cntpCtnt;
              }

              temp.value = cntpCtnt;
              temp.data.ovsesSMSBzwkDstcd = ovsesSMSBzwkDstcd;
              temp.data.cntpSerno = cntpSerno;
              temp.data.brncoIntnTelDstcd = brncoIntnTelDstcd;
              temp.data.cntpCtnt = cntpCtnt;
              temp.data.recvCnsntYn = recvCnsntYn;
              context.state.smsCnptList.push(temp);
            }
            resolve("success");
          },

          response => {
            // error modal open
            this._vm.$set(context.state.RBF0409E40.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 인증코드 요청
     * @param {*} context
     */
    act002_commMotpCertn: function (context) {
      context.dispatch("act006_commMotpCertn"); // 발송 초기화

      // 결과 초기화..
      context.state.sendCetrNoConfirm.out.success.certnNoCnfrmRsultDstcd = "";

      // 수신동의여부 강제 업데이트
      context.state.sendCetrNo.in.recvCnsntYn = "1";

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/sendCetrNo",
          context.state.sendCetrNo.in,
          response => {
            context.dispatch("act005_commMotpCertn"); // toast open
            context.dispatch("act004_commMotpCertn"); // 타이머 시작
            context.state.sendCetrNoConfirm.in.certnNoSerno = response.certnNoSerno;
            this._vm.$set(context.state.sendCetrNo.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.sendCetrNo.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 타이머 초기화
     * @param {*} context
     */
    act003_commMotpCertn: function (context) {
      context.state.sendTime = timerSeconds;
      clearInterval(tid);
    },
    /**
     * 타이머 시작
     * @param {}} context
     */
    act004_commMotpCertn: function (context) {
      tid = setInterval(() => {
        context.state.sendTime--;
        if (context.state.sendTime === 0) {
          context.state.sendCetrNo.messageForTimeOut = true;

          // 인증코드 확인 파라미터 초기화
          context.state.sendCetrNoConfirm.in.certnNoSerno = "";
          context.state.sendCetrNoConfirm.in.certnNo = "";
        }
      }, 1000);
    },
    /**
     * 발송 toast
     * @param {*} context
     */
    act005_commMotpCertn: function (context) {
      context.state.Toast.contents = "MOTP-CERTN-08";
      context.state.Toast.isOpen = true;
    },
    /**
     * 발송초기화
     * @param {*} context
     */
    act006_commMotpCertn: function (context) {
      context.state.sendCetrNo.messageForTimeOut = false; // timer 만료 메시지 초기화
      context.dispatch("act003_commMotpCertn"); // 타이머 초기화

      // 인증코드 요청 out 초기화
      Object.assign(context.state.sendCetrNo.out, getDefaultState().sendCetrNo.out);

      // 인증코드 확인 파라미터 초기화
      context.state.sendCetrNoConfirm.in.certnNoSerno = "";
      context.state.sendCetrNoConfirm.in.certnNo = "";
    },
    /**
     * 인증코드 확인
     * @param {*} context
     */
    act007_commMotpCertn: function (context) {
      // 결과 초기화..
      context.state.sendCetrNoConfirm.out.success.certnNoCnfrmRsultDstcd = "";

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/sendCetrNoConfirm",
          context.state.sendCetrNoConfirm.in,
          response => {
            this._vm.$set(context.state.sendCetrNoConfirm.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.sendCetrNoConfirm.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 예금계좌 상세조회
     */
    act008_commMotpCertn: function (context) {
      return new Promise(resolve => {
        // 계좌번호
        context.state.RBF0404B40.in.acno = context.state.RBF0404B40.acnoSelect.acno.split(";")[0];
        // 계좌구분코드
        context.state.RBF0404B40.in.acnDsticCd = context.state.RBF0404B40.acnoSelect.acnoDetail.acnKnd;

        this._vm.$post(
          "/auth/motp/" + context.state.RBF0404B40.in.bizDscd + "/RBF0404B40",
          context.state.RBF0404B40.in,
          response => {
            this._vm.$set(context.state.RBF0404B40.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.RBF0404B40.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 고객연락처상세정보변경
     */
    act009_commMotpCertn: function (context) {
      context.state.RBF0509E51.in.brncoCntpDstcd = "03";
      context.state.RBF0509E51.in.ovsesSMSBzwkDstcd = context.state.sendCetrNo.in.ovsesSMSBzwkDstcd;
      context.state.RBF0509E51.in.cntpSerno = context.state.sendCetrNo.in.cntpSerno;
      context.state.RBF0509E51.in.natnlCd = context.state.sendCetrNo.in.certnNatnlCd;
      context.state.RBF0509E51.in.cntpCtnt = context.state.sendCetrNo.in.certnCphnNo;
      context.state.RBF0509E51.in.recvCnsntYn = context.state.sendCetrNo.in.recvCnsntYn;
      console.log("****** context.state.RBF0509E51.in START");
      console.log(context.state.RBF0509E51.in);
      console.log("*****************************************");
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/RBF0509E51",
          context.state.RBF0509E51.in,
          response => {
            this._vm.$set(context.state.RBF0509E51.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.RBF0509E51.out, "fail", response);
            resolve("fail");
          },
        );
      });

    },
    /**
     * OTP 인증
     */
    act010_commMotpCertn: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/otpConfirm",
          context.state.checkOtp.in,
          response => {
            this._vm.$set(context.state.checkOtp.out, "success", response);
            context.state.successFncForBiz(); // 거래 성공시 업무 함수 호출
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.checkOtp.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 보안장치고유식별번호(tokenOTP) 조회
     */
    act011_commMotpCertn: function (context) {
      return new Promise(resolve => {
        this._vm.$post("/auth/motp/common/getOtpUniqIdnfiNo", {}, response => {
          context.state.checkOtp.in.otpUniqIdnfiNo = response.otpUniqIdnfiNo;
          resolve("success");
        });
      });
    },
    /**
     * OTP 인증 초기화
     */
    act012_commMotpCertn: function (context) {
      Object.assign(context.state.checkOtp, getDefaultState().checkOtp);
    },
    /**
     * 예금계좌상세조회 초기화
     */
    act013_commMotpCertn: function (context) {
      Object.assign(context.state.RBF0404B40, getDefaultState().RBF0404B40);
    },
    /**
     * 은행이체한도 조회
     */
    act014_commMotpCertn: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/motp/common/RBF0402N41",
          { scurtyDeviVndrDstcd: this._vm.$config.SCURTY_DEVI_VNDR_DSTCD_701, ppsnCoprDstcd: this._vm.$config.USERTYPE_PPSN },
          response => {
            this._vm.$set(context.state.RBF0402N41.out, "success", response.outItem);
            resolve("success");
          },
        );
      });
    },

    act_sendCetrNo_init: context => {
      console.log("****** act_sendCetrNo_init");
      context.state.sendCetrNo = getDefaultState().sendCetrNo;
    },

    act_sendCetrNoConfirm_init: context => {
      console.log("****** act_sendCetrNoConfirm_init");
      context.state.sendCetrNoConfirm = getDefaultState().sendCetrNoConfirm;
    },

    act_setComponent: function (context, component) {
      console.log("************************");
      console.log(component);
      if (component === "SelfCertnComm") {
        context.state.components.isSelfCertnComm = true;  // 인증 공통처리
        context.state.components.isSmsFrstCertn = false;  // sms 최초인증
        context.state.components.isSmsEmailCertn = false; // sms/email 인증
      }
      else if (component === "SmsFrstCertn") {
        context.state.components.isSelfCertnComm = false;  // 인증 공통처리
        context.state.components.isSmsFrstCertn = true;  // sms 최초인증
        context.state.components.isSmsEmailCertn = false; // sms/email 인증
      }
      else if (component === "SmsEmailCertn") {
        context.state.components.isSelfCertnComm = false;  // 인증 공통처리
        context.state.components.isSmsFrstCertn = false;  // sms 최초인증
        context.state.components.isSmsEmailCertn = true; // sms/email 인증
      }
      console.log(context.state.components.isSelfCertnComm);
      console.log(context.state.components.isSmsFrstCertn);
      console.log(context.state.components.isSmsEmailCertn);
      console.log("************************");

    },



  },
};

export default commMotpCertn;